import { omsFetch } from './utils';

export default class {
  constructor() {
    this.preSubmitCallbacks = [];
    this.successCallbacks = [];
    this.failureCallbacks = [];
    this.isInProgress = false;
  }

  addPreSubmitCallback(callback) {
      this.preSubmitCallbacks.push(callback);
  }

  addFailureCallback(callback) {
    this.failureCallbacks.push(callback);
  }

  addSuccessCallback(callback) {
    this.successCallbacks.push(callback);
  }

  submitWithRemoteValidation(id) {

    const form = document.getElementById(id);
      if (!form) {
    console.warn(`Form not found: ${id}`);
    return;
  }

    form.addEventListener('submit', event => {
      event.preventDefault();
      event.stopPropagation();

      if (!this.isInProgress) {
        this.isInProgress = true;

        for (const callback of this.preSubmitCallbacks) {
          callback();
        }

        if (window.CKEDITOR !== undefined) {
          for (const i in CKEDITOR.instances) {
            CKEDITOR.instances[i].updateElement();
          }
        }

        const thisValidator = this;

        omsFetch({
          serviceUrl: form.action,
          method: 'POST',
          params: new FormData(form),
          contentType: false
        }).then((response) => {
          if (response.status === 'created' || response.status === 'ok') {
            for (const callback of thisValidator.successCallbacks) {
              callback(response);
            }
            if (response.redirect) {
              location.replace(response.redirect);
            }
          } else {
            console.error(response);
            for (const callback of thisValidator.failureCallbacks) {
              callback(response);
            }
          }
        }).catch((error) => {
          console.error('Szerveroldali hiba történt!');
          console.error(error);
          for (const callback of thisValidator.failureCallbacks) {
            callback(error);
          }
        }).finally(() => {
          thisValidator.isInProgress = false;
        });
      }
      return false;
    });
  }
}
